export default "__VITE_ASSET__mCLsf_q4__"